define.alias("shared/modifiers/on-escape-key-up", "media/modifiers/on-escape-key-up");